import { Box, Paper, PaperProps, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';


const useStyles = makeStyles()((theme) => ({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.5),
    color: theme.palette.common.white
  },
}));

const useColorStyles = makeStyles()((theme) => ({
  purpleDark: {
    background: theme.palette.secondary.dark,
  },
  purple: {
    background: theme.palette.secondary.main,
  },
  purpleLight: {
    background: theme.palette.secondary.light,
  },
  green: {
    background: theme.palette.primary.main,
  },
  greenLight: {
    background: theme.palette.primary.light,
  },
  greenDark: {
    background: theme.palette.primary.dark,
  }
}));

export type FinanceSummaryCardProps = {
  label: string;
  value: React.ReactNode;
  icon: React.ReactNode;
  sx?: PaperProps['sx'];
  iconContainerClassName?: string;
  color?: 'purpleDark' | 'purple' | 'purpleLight' | 'green' | 'greenLight' | 'greenDark';
};

export const FinanceSummaryCard: React.VFC<FinanceSummaryCardProps> = ({ label, value, icon, iconContainerClassName, color, sx }) => {
  const { classes: colorClasses } = useColorStyles();
  const { classes, cx } = useStyles();
  const colorClassName = color ? colorClasses[color] : iconContainerClassName;

  return (
    <Box
      component={Paper} variant="outlined"
      sx={[
        {
          p: 2,
          pr: 4,
          display: 'flex',
          gap: '1rem',
          alignItems: 'center',
        },
        ...(Array.isArray(sx) ? sx : [ sx ])
      ]}
    >
      <Box className={cx(classes.iconContainer, colorClassName)}>
        {icon}
      </Box>
      <Box>
        <Typography>{value}</Typography>
        <Typography variant="body2">{label}</Typography>
      </Box>
    </Box>
  );
};
